import Button from "@/components/button/Button"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { FC, useState } from "react"
import "./AoiSubmittingConfirmation.less"

const { Title, Paragraph } = WebsiteTypography

const AoiSubmittingConfirmation: FC = () => {
  const { xxl, xl, lg, md, sm } = useBreakpoint()
  const isMobileScr = !(xxl || xl || lg || md || sm)
  const { setIsModalDarkOpen, onSubmit } = useModalDarkContext()

  const [loading, setLoading] = useState(false)

  const handleSubmitNow = () => {
    setLoading(true)
    onSubmit?.()
    setIsModalDarkOpen(false)
  }

  const handleClose = () => {
    setIsModalDarkOpen(false)
  }

  return (
    <Row justify={"center"} className={"submitting-confirmation-wrapper"} style={{ paddingBottom: 24 }}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        {!isMobileScr && (
          <Row justify={"center"} className={"submitting-svg-wrapper"}>
            <div className={"submitting-hex-wrapper"}>
              <SvgIcon type={"envelope-upload"} />
            </div>
          </Row>
        )}

        <Title level={isMobileScr ? 5 : 3} centered className={"section-title"} style={{ paddingTop: 12 }}>
          <span className={"bold"}>{"AOI Submission Confirmation"}</span>
        </Title>

        <Row justify={"center"} className={"submitting-svg-wrapper"} style={{ paddingTop: 12 }}>
          {isMobileScr && <SvgIcon type={"envelope-upload"} />}
        </Row>

        <Row justify={"center"}>
          <Col span={24}>
            <Paragraph
              centered
              size={"sm"}
              style={{ paddingTop: 24, paddingBottom: 24 }}
              color={"website-secondary"}
              weight={"w300"}
            >
              <span className={"bold"}>{"By clicking “Confirm”"}</span>
              <span>
                {
                  ", you agree that all information provided for your project is accurate and complete, including location, construction details, and applicant information. You understand that incorrect or incomplete information may lead to an inaccurate assessment and potential damage to our services, for which you will be responsible.\n\nYou also accept that any damage to our services related to this project will be at your cost, regardless of our assessment outcome, including if the project is marked as “not affected”."
                }
              </span>
            </Paragraph>
          </Col>
        </Row>
      </Col>

      <Row justify={"center"} className={"divider-with-hex"} style={{ margin: "0 0 24px 0" }}>
        <div className={"hex-small"} />
      </Row>

      <Col span={isMobileScr ? 22 : 16}>
        <Row justify={"center"}>
          <Paragraph weight={"w300"} size={isMobileScr ? "xs" : "sm"} color={"website-secondary"} centered>
            {
              "If you would like to review your application or add additional documents, please click “Close” and select “Save & Review Later” on the previous screen."
            }
          </Paragraph>
        </Row>
      </Col>

      <Row justify={"center"} style={{ paddingTop: 32 }} gutter={[16, 16]}>
        <Col span={isMobileScr ? 24 : 12}>
          <Button
            btnType={"ghost"}
            text={"Close"}
            onClick={handleClose}
            loading={loading}
            block
            textColor={"white"}
            size={"large"}
          />
        </Col>

        <Col span={isMobileScr ? 24 : 12}>
          <Button
            btnType={"primary"}
            text={"Confirm"}
            onClick={handleSubmitNow}
            loading={loading}
            block
            size={"large"}
          />
        </Col>
      </Row>
    </Row>
  )
}

export default AoiSubmittingConfirmation
